import React, { useState, useEffect, useRef } from 'react'
import { Button, Card, Avatar, ToggleButtonGroup, ToggleButton, Modal, Box, Grid, Paper, SpeedDial, SpeedDialIcon, SpeedDialAction } from '@mui/material';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import EventIcon from '@mui/icons-material/Event';
import CloseIcon from '@mui/icons-material/Close';




const FloatingActionButton = () => {
    const navigate = useNavigate();
    const [open, setOpen] = useState(false);

    const actions = [
        { icon: <EventIcon />, name: 'Crear Evento', action: () => navigate('/createevent') }
    ];

    return (
        <>
            <Box
                sx={{
                    bottom: 'env(safe-area-inset-bottom)',
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    bgcolor: 'rgba(0, 0, 0, 0.5)',
                    zIndex: (theme) => theme.zIndex.speedDial - 1,
                    transition: 'opacity 0.3s',
                    opacity: open ? 1 : 0,
                    pointerEvents: open ? 'auto' : 'none',
                }}
                onClick={() => setOpen(false)}
            />
            <SpeedDial
                ariaLabel="SpeedDial"
                sx={{
                    position: 'fixed',
                    bottom: { xs: 90, sm: 64 }, // Adjusted for mobile navigation bar
                    right: 32,
                    '& .MuiFab-primary': {
                        bgcolor: '#3f51b5',
                        '&:hover': {
                            bgcolor: '#303f9f'
                        }
                    }
                }}
                icon={<SpeedDialIcon openIcon={<CloseIcon />} />}
                onClose={() => setOpen(false)}
                onOpen={() => { setOpen(true) }}
                open={open}
            >
                {actions.map((action) => (
                    <SpeedDialAction
                        key={action.name}
                        icon={action.icon}
                        tooltipTitle={action.name}
                        onClick={action.action}
                        tooltipOpen
                        sx={{
                            '&.MuiSpeedDialAction-fab': {
                                bgcolor: '#f5f5f5',
                                '&:hover': {
                                    bgcolor: '#e0e0e0'
                                },
                                width: 'auto',
                                paddingInline: 2
                            },
                            '& .MuiSpeedDialAction-staticTooltipLabel': {
                                // backgroundColor: 'transparent',
                                color: 'inherit',
                                fontSize: '0.875rem',
                                marginLeft: 1,
                                whiteSpace: 'nowrap'
                            }
                        }}
                    />
                ))}
            </SpeedDial>
        </>
    );
};

export default FloatingActionButton
